import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {CopilotCodeReviewFindings} from '@github-ui/copilot-code-review-findings'
import {pullRequestsFindingsRoute} from './findings-route'
import {PullRequestStoreProvider} from '../stores/PullRequestStore'

export function FindingsEntrypoint() {
  const {
    data: {files, ...findings},
  } = useRouteQuery(pullRequestsFindingsRoute, 'mainQuery')

  return (
    <PullRequestStoreProvider initData={files}>
      <CopilotCodeReviewFindings {...findings} />
    </PullRequestStoreProvider>
  )
}
